import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '40%',
  },
  title: {
    color: theme.palette.text.primary,
    fontSize: '1.25rem',
    textTransform: 'uppercase',
    fontWeight: '800',
    marginBottom: '0.5rem',
  },
  errorIcon: {
    color: theme.palette.error.main,
  },
}));

export default useStyles;
